export const AREA_LINE = "Serving Albuquerque, Rio Rancho, Los Lunas, Corrales & Santa Fe, New Mexico.";
export const TRAVEL_NOTE = "Scheduling and any applicable travel charges will be confirmed with your estimate.";
export const OUTSIDE_NOTE = "Outside these areas? Contact us to check availability.";

export const CITIES = [
  {
    slug: "albuquerque",
    key: "albuquerque",
    name: "Albuquerque",
    title: "Handyman Help, Junk Removal & Cleanups in Albuquerque",
    seo: "Handyman help, junk removal, yard cleanup and property cleanouts in Albuquerque, NM from locally owned One Punch Services. Written estimates and 20% off eligible services for seniors.",
    headline: "Albuquerque is home base.",
    intro: [
      "One Punch Services is based in Albuquerque, so this is where our day starts. Whether it's one stubborn item in the garage or a list of small jobs that keeps getting pushed to next weekend, you can tell us about it in a few minutes.",
      "We help homeowners, seniors, adult children helping a parent, landlords between tenants, and realtors getting a home ready to list. Every job starts with a written estimate you approve before any work begins.",
    ],
    help: [
      ["Junk removal", "Old couches, mattresses, disconnected appliances, boxes and general clutter — loaded and hauled away."],
      ["Handyman help", "Small household tasks within our offered service scope, including furniture assembly."],
      ["Property & rental cleanouts", "Move-out and turnover cleanouts, with before-and-after photos for owners and managers."],
      ["Yard cleanup", "Leaves, weeds and nonhazardous yard debris cleared and hauled."],
      ["Senior home support", "Patient help with decluttering, downsizing and small approved tasks."],
    ],
    tips: [
      "Have a mix of jobs? Put them all in one request — we can quote them together.",
      "Photos help, but you can always just call and describe what you need.",
    ],
    faq: [
      ["Can you handle a few small jobs in one visit?", "Often, yes. List everything in your request and we'll let you know what can fit into one visit and what it would cost before anything is scheduled."],
      ["I'm a landlord. Can you document the cleanout?", "Yes. Before-and-after documentation is available for property and rental cleanouts — just mention it in your request."],
    ],
  },
  {
    slug: "rio-rancho",
    key: "rio_rancho",
    name: "Rio Rancho",
    title: "Junk Removal, Handyman Help & Yard Cleanup in Rio Rancho",
    seo: "One Punch Services helps Rio Rancho, NM homeowners with garage cleanouts, furniture assembly, junk removal and yard cleanup. Clear written estimates; seniors save 20% for life on eligible services.",
    headline: "Help for Rio Rancho homes, garages and yards.",
    intro: [
      "Rio Rancho sits just northwest of Albuquerque, and it's one of the cities we serve from our Albuquerque base. If your garage has turned into storage, a new piece of furniture is still in its box, or the yard needs clearing, we can help.",
      "Send a request with a short description — and photos if you have them — and we'll follow up with a clear, itemized estimate. Nothing is scheduled until you approve it.",
    ],
    help: [
      ["Garage and storage cleanouts", "We load and haul what you no longer need so you can use your garage again."],
      ["Furniture assembly", "Desks, tables and shelving units put together within our offered service scope."],
      ["Yard cleanup", "Leaves, weeds and yard debris cleared, or piles you've already gathered loaded and hauled."],
      ["Junk removal", "Furniture, mattresses and already-disconnected appliances removed."],
      ["Property cleanouts & senior support", "Move-out cleanouts, downsizing help and small approved tasks for seniors."],
    ],
    tips: [
      "For garage cleanouts, a wide photo of the whole space helps us estimate the load.",
      "Let us know if anything needs to be taken apart before it can be carried out.",
    ],
    faq: [
      ["Do you charge extra to come to Rio Rancho?", "If a travel charge applies, it will be listed on your written estimate before you approve anything. Scheduling is confirmed with your estimate too."],
      ["Can you assemble furniture and haul away the boxes?", "Yes — mention both in your request and we'll include them in one estimate."],
    ],
  },
  {
    slug: "los-lunas",
    key: "los_lunas",
    name: "Los Lunas",
    title: "Property Cleanups, Junk Removal & Handyman Help in Los Lunas",
    seo: "Junk removal, property cleanouts, yard cleanup and handyman help in Los Lunas, NM. Combine tasks into one planned visit. Written estimates; seniors save 20% for life on eligible services.",
    headline: "Planned visits for Los Lunas homes and properties.",
    intro: [
      "Los Lunas is south of Albuquerque in Valencia County, and we plan visits there ahead of time. That makes it a good fit for bigger cleanup days or for bundling several tasks into a single trip.",
      "Many requests come from family members helping a parent or managing a property from a distance. With the customer's permission, we can coordinate with you and share completion updates.",
    ],
    help: [
      ["Property and estate cleanouts", "Sorting what stays, what's donated and what goes, then clearing the rest."],
      ["Yard cleanup", "Clearing yard debris and hauling it away."],
      ["Junk removal", "Large items, household clutter and already-disconnected appliances."],
      ["Senior home support", "Decluttering, downsizing and small approved tasks — on your schedule, at your pace."],
      ["Handyman help", "Small household tasks within our offered service scope, including furniture assembly."],
    ],
    tips: [
      "Bundling jobs into one visit is often the simplest way to get everything done.",
      "Tell us who is authorized to approve removal if you're arranging a cleanout for someone else.",
    ],
    faq: [
      ["Can I arrange a cleanout for my parent in Los Lunas?", "Yes. Tell us what's needed and confirm your parent's permission in the form. We'll coordinate appointments with you and share completion updates."],
      ["How is scheduling handled?", "Your preferred date is a request. Scheduling and any applicable travel charges are confirmed with your estimate."],
    ],
  },
  {
    slug: "corrales",
    key: "corrales",
    name: "Corrales",
    title: "Yard Cleanup, Hauling & Handyman Help in Corrales",
    seo: "Yard debris cleanup, junk hauling, downsizing help and small handyman tasks in Corrales, NM. Itemized written estimates; seniors save 20% for life on eligible services.",
    headline: "Yard, hauling and household help in Corrales.",
    intro: [
      "Corrales is a village between Albuquerque and Rio Rancho. We can help with outdoor cleanup, hauling unwanted items, and the indoor projects that come up when it's time to declutter or downsize.",
      "Because every property is set up differently, we ask a few questions about access — gates, driveways and how far items need to be carried — so your estimate is accurate from the start.",
    ],
    help: [
      ["Yard cleanup and debris hauling", "Leaves, weeds, branches and other nonhazardous green waste cleared and hauled."],
      ["Junk removal", "Old furniture, mattresses and outbuilding or garage clutter loaded and taken away."],
      ["Decluttering and downsizing", "Patient help sorting and clearing rooms, including senior home support."],
      ["Handyman help", "Small household tasks within our offered service scope, including furniture assembly."],
      ["Property cleanouts", "Move-out, pre-sale and estate cleanouts with optional before-and-after photos."],
    ],
    tips: [
      "Mention gate widths, long carries or narrow paths — please don't include gate codes.",
      "A photo of the route from where a truck can park to the items is very helpful.",
    ],
    faq: [
      ["Can you just load piles I've already gathered?", "Yes. Choose 'Loading & hauling only' in the yard cleanup section of the request form."],
      ["Will there be a travel charge?", "If one applies, it will be shown on your written estimate before you approve. We don't add charges you haven't seen."],
    ],
  },
  {
    slug: "santa-fe",
    key: "santa_fe",
    name: "Santa Fe",
    title: "Estate Cleanouts, Junk Removal & Handyman Help in Santa Fe",
    seo: "One Punch Services serves Santa Fe, NM with planned visits for estate and downsizing cleanouts, rental turnovers, junk removal and small handyman tasks. Written estimates; seniors save 20% for life on eligible services.",
    headline: "Planned, well-organized visits to Santa Fe.",
    intro: [
      "Santa Fe is about an hour north of our Albuquerque base, so we schedule Santa Fe work ahead of time and plan each visit carefully. That works well for larger projects like estate and downsizing cleanouts, rental turnovers, or a full list of household tasks.",
      "Your written estimate lays out the scope, the price, and any applicable travel charge before you approve — so you know exactly what to expect.",
    ],
    help: [
      ["Estate and downsizing cleanouts", "Careful sorting of what to keep, donate and remove, with respect for family belongings."],
      ["Rental-property cleanup", "Turnover cleanouts for owners and property managers, with before-and-after documentation."],
      ["Junk removal", "Furniture, mattresses, clutter and already-disconnected appliances hauled away."],
      ["Senior home support", "Help with decluttering and small approved tasks, with optional family coordination."],
      ["Handyman help & yard cleanup", "Small household tasks within our offered service scope, including furniture assembly, plus yard debris cleanup."],
    ],
    tips: [
      "Give us your ideal completion date and a little flexibility — it helps us plan the trip.",
      "If several people are involved in a cleanout, tell us who approves what can be removed.",
    ],
    faq: [
      ["Can you come to Santa Fe on short notice?", "We plan Santa Fe visits in advance and can't promise same-day service. Send your preferred dates and we'll confirm scheduling with your estimate."],
      ["Is there a travel charge for Santa Fe?", "If a travel charge applies, it will be listed on your written estimate before you approve anything."],
    ],
  },
];
